<div class="container public-page-suggested-media mb-30">
    <app-public-group></app-public-group>
</div>
